import { render, staticRenderFns } from "./AiMarketingService.vue?vue&type=template&id=b4a2c25c&scoped=true"
import script from "./AiMarketingService.vue?vue&type=script&lang=js"
export * from "./AiMarketingService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a2c25c",
  null
  
)

export default component.exports